<template>
    <BasePanel
        headline="lang_GENERAL_CAPTION_PDF"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-container fluid>
                <v-row justify="center">
                    <v-col
                        cols="10"
                        v-if="item.path !== null"
                    >
                        <iframe
                            v-if="pdfBlobUrl"
                            :src="pdfBlobUrl"
                            frameborder="0"
                            width="90%"
                            height="800px"
                        ></iframe>
                        <div
                            v-else-if="loadError"
                            class="v-data-table__empty-wrapper"
                            :alvqa="alvqa + '-load-error-text'"
                        >
                            {{ $t('lang_GENERAL_CAPTION_NO_DATA_AVAILABLE') }}
                        </div>
                        <div
                            v-else
                            class="d-flex justify-center pa-4"
                        >
                            <v-progress-circular
                                indeterminate
                                color="primary"
                            ></v-progress-circular>
                        </div>
                    </v-col>
                    <v-col
                        class="v-data-table__empty-wrapper"
                        cols="10"
                        v-else
                    >
                        <div :alvqa="alvqa + '-list-no-data-text'">
                            {{ $t('lang_GENERAL_CAPTION_NO_DATA_AVAILABLE') }}
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BasePanel>
</template>

<script>
import api from '@/api_alv'
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "PdfReadonlyPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon
    },
    props: {
        sheetAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'publishing-sheets-list-row-' + this.sheetAlvId + '-read-only-panel-pdf',
            pdfBlobUrl: null,
            loadError: false
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedSheets.find(element => {
                return element.alvId === this.sheetAlvId
            })
            return item
        },
    },
    watch: {
        // The secure path can change when a different sheet is expanded, so
        // (re)load the preview whenever it does.
        'item.path': {
            immediate: true,
            handler() {
                this.loadPdf()
            }
        }
    },
    beforeDestroy() {
        this.revokeBlobUrl()
    },
    methods: {
        // The BE returns the PDF behind a secure URL served with
        // `Content-Disposition: inline`, which makes the browser download
        // the file instead of previewing it — even inside an <iframe>. We fetch
        // the bytes ourselves and render them through a blob: object URL, which
        // the disposition header does not apply to, so the PDF shows inline.
        async loadPdf() {
            this.revokeBlobUrl()
            this.loadError = false

            const path = this.item && this.item.path
            if (!path) {
                return
            }

            try {
                const blob = await api.getFileBlobFromALV(path)
                // Force the type so the browser opens its native PDF viewer even
                // if the response Content-Type is generic (e.g. octet-stream).
                const pdfBlob = blob.type === 'application/pdf'
                    ? blob
                    : new Blob([blob], { type: 'application/pdf' })
                this.pdfBlobUrl = window.URL.createObjectURL(pdfBlob)
            } catch (error) {
                this.loadError = true
            }
        },
        revokeBlobUrl() {
            if (this.pdfBlobUrl) {
                window.URL.revokeObjectURL(this.pdfBlobUrl)
                this.pdfBlobUrl = null
            }
        }
    }
}
</script>
